import { CompanyServer } from '@/api/company/companyServer';

const publicPath = require('../config/index').jsonPath;
import { RequireFilter } from '@/filter/RequireFilter';
import { DemoServer } from './feature/demoServer';
import { LoginServe } from './feature/loginServe';
import { ProfessionServer } from './feature/professionServer';
import { InstitutionServer } from './feature/institutionServer';
import { SpaceServe } from '@/api/feature/spaceServe';
import { MenuServe } from '@/api/feature/menuServe';
import { RoleServe } from '@/api/feature/roleServe';
import { UserServe } from '@/api/feature/userServe';
import { DictServe } from '@/api/feature/dictServe';
import { UserManagementServe } from '@/api/feature/userManagementServe';
import { ProcessServe } from '@/api/feature/processServe';
import { GetArea } from '@/api/service/getArea';
import { RegionServe } from '@/api/feature/regionServe';
import { PatrolManagementServe } from '@/api/feature/patrolManagementSever';
import { SchedulePlan } from '@/api/feature/schedulePlan';
import { InfoServer } from '@/api/feature/infoServer';
import { IntegralManagementServer } from '@/api/feature/integralManagementServer';
import { PerformanceServer } from '@/api/performance/performanceServer';
import { DutyListTemplateServer } from '@/api/performance/dutyListTemplateServer';
import { DutyListBatchServer } from '@/api/performance/dutyListBatchServer';
import { SiteManagementServer } from '@/api/siteManagement/siteManagementServer';
import { SafetyAndEnvironmentAssessmentServer } from '@/api/safetyAndEnvironmentAssessment/safetyAndEnvironmentAssessmentServer';
import { HiddenDangerLibraryServer } from '@/api/hiddenDangerLibrary/hiddenDangerLibraryServer';
import { DoublePrevention } from '@/api/feature/doublePrevention';
import { YunnanDataViewServer } from '@/api/feature/yunnanDataViewServer';
import { VideoManagement } from '@/api/feature/videoManagement';
import { DeviceServer } from '@/api/feature/device';
import { PanoramicQueryServer } from '@/api/panoramicQuery/panoramicQueryServer';

// 基础功能
import { TagServer } from '@/api/base/tagServer';

import { GetImgServer } from '@/api/service/getImgServer';
import { TrainServer } from '@/api/train/trainServer';
import { ZyScreenServer } from '@/api/zyScreen/zyScreenServer';
import { TemporaryWorkServer } from '@/api/temporaryWork/temporaryWorkServer';
import { GetSignatureServer } from '@/api/service/getSignatureServer';
import { OneClickAlarm } from '@/api/oneClickAlarm/oneClickAlarm';

const requireFilter: RequireFilter = new RequireFilter();
const injectFilter: any = (servObj: any) => {
  requireFilter.axiosFilter.request(servObj);
  requireFilter.axiosFilter.response(servObj);
};

const demoServer = new DemoServer({ baseURL: publicPath }, injectFilter);
const loginServe = new LoginServe({ baseURL: publicPath }, injectFilter);
const professionServer = new ProfessionServer({ baseURL: publicPath }, injectFilter);
const institutionServer = new InstitutionServer({ baseURL: publicPath }, injectFilter);
const spaceServe = new SpaceServe({ baseURL: publicPath }, injectFilter);
const menuServe = new MenuServe({ baseURL: publicPath }, injectFilter);
const roleServe = new RoleServe({ baseURL: publicPath }, injectFilter);
const dictServe = new DictServe({ baseURL: publicPath }, injectFilter);
const userManagementServe = new UserManagementServe({ baseURL: publicPath }, injectFilter);
const userServe = new UserServe({ baseURL: publicPath }, injectFilter);
const processServe = new ProcessServe({ baseURL: publicPath }, injectFilter);
const regionServe = new RegionServe({ baseURL: publicPath }, injectFilter);
const patrolManagementServe = new PatrolManagementServe({ baseURL: publicPath }, injectFilter);
const schedulePlan = new SchedulePlan({ baseURL: publicPath }, injectFilter);
const infoServer = new InfoServer({ baseURL: publicPath }, injectFilter);
const integralManagementServer = new IntegralManagementServer({ baseURL: publicPath }, injectFilter);
const performanceServer = new PerformanceServer({ baseURL: publicPath }, injectFilter);
const dutyListTemplateServer = new DutyListTemplateServer({ baseURL: publicPath }, injectFilter);
const dutyListBatchServer = new DutyListBatchServer({ baseURL: publicPath }, injectFilter);
const panoramicQueryServer = new PanoramicQueryServer({ baseURL: publicPath }, injectFilter);
const siteManagementServer = new SiteManagementServer({ baseURL: publicPath }, injectFilter);
const safetyAndEnvironmentAssessmentServer = new SafetyAndEnvironmentAssessmentServer({ baseURL: publicPath }, injectFilter);
const hiddenDangerLibraryServer = new HiddenDangerLibraryServer({ baseURL: publicPath }, injectFilter);
const doublePrevention = new DoublePrevention({ baseURL: publicPath }, injectFilter);
const yunnanDataViewServer = new YunnanDataViewServer({ baseURL: publicPath }, injectFilter);

// 公共请求
const getImgServer = new GetImgServer({ baseURL: publicPath }, injectFilter);
const getArea = new GetArea({ baseURL: publicPath }, injectFilter);

// 临时作业
const temporaryWorkServer = new TemporaryWorkServer({ baseURL: publicPath }, injectFilter);

const trainServer = new TrainServer({ baseURL: publicPath }, injectFilter);

const getSignatureServer = new GetSignatureServer({ baseURL: publicPath }, injectFilter);

// 基础功能
const tagServer = new TagServer({ baseURL: publicPath }, injectFilter);
const videoManagement = new VideoManagement({ baseURL: publicPath }, injectFilter);
const deviceServer = new DeviceServer({ baseURL: publicPath }, injectFilter);

// 资阳 大屏
const zyScreenServer = new ZyScreenServer({ baseURL: publicPath }, injectFilter);
const companyServer = new CompanyServer({ baseURL: publicPath }, injectFilter);
const oneClickAlarmServer = new OneClickAlarm({ baseURL: publicPath }, injectFilter);

export {
  // 公共api
  getImgServer, // 根据id数组获取图片
  getArea, // 获取区域、街道
  // 业务api
  demoServer, // api 模板
  loginServe, // 登录页面
  professionServer, // 岗位页面接口
  institutionServer, // 机构管理页面接口
  spaceServe, // 空间管理页面接口
  menuServe, // 菜单管理页面接口
  roleServe, // 角色页面接口
  dictServe, // 字典页面接口
  userManagementServe, // 用户管理页面接口
  userServe, // 用户管理页面接口
  processServe, // 流程分组弹框接口
  performanceServer, // 履职管理接口
  dutyListTemplateServer, // 履职清单模板
  dutyListBatchServer, // 履职清单批量记录
  siteManagementServer, // 作业票接口
  safetyAndEnvironmentAssessmentServer, // 安环考核接口
  hiddenDangerLibraryServer, // 隐患库接口
  doublePrevention, // 双重预防
  // 数据大屏
  regionServe, // 区域管理接口
  patrolManagementServe, // 巡检管理接口
  schedulePlan,
  infoServer, // 系统消息
  integralManagementServer, // 积分管理
  // 基础功能
  tagServer, // 标签
  yunnanDataViewServer, // 云南大屏
  videoManagement, // 视频管理
  trainServer, // 培训
  deviceServer, // 设备信息
  panoramicQueryServer, // 企业主体信息
  zyScreenServer, // 资阳  大屏
  companyServer, // 企业 api
  temporaryWorkServer, // 临时作业
  getSignatureServer, // 签名
  oneClickAlarmServer, // 一键报警
};
